import { useContext, useCallback, useState, memo } from "react";
import { useStaticQuery, graphql } from "gatsby";
import PropTypes from "prop-types";

import { GeoContext } from "@context/GeoProvider";
import { edgesToArray } from "@helpers/general";
import { withALErrorBoundary } from "@helpers/ErrorBoundary/ALErrorBoundary";
import ErrorBoundary from "@components/ErrorBoundary";
import Menu from "@components/header/desktopMenu/Menu";

function DesktopMenu({ onShowMenu }) {
  const { gePriceDetails } = useContext(GeoContext);
  const [openMenuId, setOpenMenuId] = useState(null);

  const { allContentfulMenuWrapper } = useStaticQuery(graphql`
    query Menu {
      allContentfulMenuWrapper {
        edges {
          node {
            id
            node_locale
            countries {
              code
            }
            desktopMenuItems {
              id
              title
              node_locale
              textColor
              contentful_id
              menuContainer {
                id
                title
                menuCategories: menuCategory {
                  ... on ContentfulMenuCategory {
                    id
                    title
                    titleLink
                    fontColor
                    links {
                      id
                      title
                      link {
                        link
                      }
                    }
                  }
                }
                imageLinks: menuLinkWithImage {
                  id
                  title
                  link {
                    title
                    link {
                      link
                    }
                  }
                  image {
                    altText
                    desktopImage {
                      gatsbyImageData(layout: CONSTRAINED, width: 600, placeholder: BLURRED)
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `);

  let menus = null;
  if (allContentfulMenuWrapper?.edges && allContentfulMenuWrapper?.edges.length > 0) {
    const allMenuArray = edgesToArray(allContentfulMenuWrapper);
    const defaultMenu = allMenuArray.find((n) => n?.countries?.some((c) => c.code === "RoW"));

    const localeSpecificMenu = allMenuArray.filter((n) =>
      n?.countries?.some((c) => c.code === gePriceDetails?.CountryCode)
    );
    const localeSpecificMenuRoot = localeSpecificMenu.find(
      (b) => b.node_locale === gePriceDetails.Culture
    );
    menus = localeSpecificMenuRoot?.desktopMenuItems ?? defaultMenu.desktopMenuItems;
  }

  const showMenu = useCallback(
    (title) => {
      if (typeof onShowMenu === "function") {
        onShowMenu(title);
      }
    },
    [onShowMenu]
  );

  return (
    <ErrorBoundary>
      <div
        className="w-full flex flex-row gap-[30px] whitespace-nowrap"
        onMouseLeave={() => setOpenMenuId(null)}
      >
        {menus.map((menu) => (
          <Menu
            key={menu.id}
            tabIndex="0"
            menu={menu}
            showMenu={showMenu}
            openMenuId={openMenuId}
            setOpenMenuId={setOpenMenuId}
          />
        ))}
      </div>
    </ErrorBoundary>
  );
}

DesktopMenu.propTypes = {
  onShowMenu: PropTypes.func,
};

export default memo(
  withALErrorBoundary({
    name: "DesktopMenu",
    priority: "P2",
  })(DesktopMenu)
);
